// ============================================
// THEME UTILITIES
// ============================================

/**
 * Get theme-aware class names based on dark mode state
 * @param {boolean} isDarkMode - Whether dark mode is enabled
 * @returns {Object} Object containing theme-aware class names
 */
export const getThemeClasses = (isDarkMode) => ({
  // Backgrounds
  bgPrimary: isDarkMode ? 'bg-slate-900' : 'bg-slate-50',
  bgSecondary: isDarkMode ? 'bg-slate-800' : 'bg-white',
  bgTertiary: isDarkMode ? 'bg-slate-700' : 'bg-slate-50',
  bgHover: isDarkMode ? 'hover:bg-slate-700' : 'hover:bg-slate-50',

  // Text
  textPrimary: isDarkMode ? 'text-slate-100' : 'text-slate-800',
  textSecondary: isDarkMode ? 'text-slate-300' : 'text-slate-600',
  textTertiary: isDarkMode ? 'text-slate-400' : 'text-slate-500',
  textMuted: isDarkMode ? 'text-slate-500' : 'text-slate-400',

  // Borders
  border: isDarkMode ? 'border-slate-700' : 'border-slate-200',
  borderLight: isDarkMode ? 'border-slate-600' : 'border-slate-100',

  // Cards
  card: isDarkMode ? 'bg-slate-800 border-slate-700' : 'bg-white border-slate-200',
  cardHover: isDarkMode ? 'hover:bg-slate-700' : 'hover:bg-slate-50',

  // Inputs
  input: isDarkMode
    ? 'bg-slate-700 border-slate-600 text-slate-100 placeholder-slate-400 focus:border-blue-500'
    : 'bg-white border-slate-300 text-slate-900 placeholder-slate-400 focus:border-blue-500',

  // Gradients
  gradient: 'bg-gradient-to-br from-slate-900 via-slate-800 to-indigo-900',
  gradientButton: 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700'
});
